'use strict';

module.exports = function () {

    $(document).on('keydown', '#country-detector', function(e){
        if (['Escape'].indexOf(e.key) != -1){
            $('#country-detector .decline, .close').trigger('click');
        }
    });

	var consentGiven = true;
	
	if(typeof CookieInformation !== "undefined" && !CookieInformation.getConsentGivenFor("cookie_cat_functional")){
		consentGiven = false;
	}
    var cookieSet = document.cookie.indexOf('dw_cookies_set_geo_locale_first_visit') >= 0;
    
    if($('meta[name="DisableCountryRedirect"]').attr('content') === 'false' && !cookieSet && consentGiven) {
        var urlContent = $('.page').data('url');
        var action = $('.page').data('action');
        var currentQuery = $('.page').data('querystring');
        if(urlContent){
            $.ajax({
                url: urlContent+"?action="+action+'&'+currentQuery,
                type: 'get',
                dataType: 'html'
            })
            .then(function (response, status, xhr) {
                if (!response){
                    document.cookie = 'dw_cookies_set_geo_locale_first_visit=1; path=/; max-age=2592000;';
                    return;
                }
                $('body').append(response);
                $('#country-detector').modal('show');
                $('#country-detector .modal-content').trigger('focus');
                $('#country-detector .decline, .close').click(function (e) {
                    e.preventDefault();
                    $('#country-detector').modal('hide');
                    $('#country-detector').remove();
                    document.cookie = 'dw_cookies_set_geo_locale_first_visit=1; path=/; max-age=2592000;';
                    $('body').trigger('focus');
                });

                $('#country-detector .affirm').on('keypress', function (e) {
                    if (['Enter'].indexOf(e.key) != -1){
                        window.location.href =  $(this).find('a').attr('href');
                    }
                })
            });
        }
    }
};


